<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div
      class="h-screen flex w-full vx-row no-gutter justify-center"
      style="background-color: #ffffff"
      id="page-login"
    >
      <vs-col vs-type="flex" vs-w="6" style="border-radius: 2.2rem">
        <div class="top-left-button">
          <vs-button href="/pages/login">Kullanıcı Paneli</vs-button>
        </div>
        <vs-row vs-type="flex" vs-justify="center">
          <vs-row
            class="text-mood"
            vs-w="12"
            vs-align="center"
            vs-justify="center"
          >
            <img :src="logo" class="responsive logo py-2 px-2" />
          </vs-row>
          <vs-row vs-type="flex" vs-w="6" vs-justify="center">
            <login-jwt :isBis="true"></login-jwt>
          </vs-row>
        </vs-row>
        
      </vs-col>
    </div>
  </template>
  
  <script>
  /*<vs-row vs-type="flex" vs-w="12" class="mt-auto">
            <img :src="footer" class="responsive" style="height:167px;" />
          </vs-row>*/
  import LoginJwt from "./LoginJWT.vue";
  import LoginMobil from "./LoginMobil";
  import companyInfo from "../../../model/constants/companyInfo";
  export default {
    components: {
      LoginJwt,
      LoginMobil,
    },
    data() {
      return {
        windowWidth: 0,
        logo: companyInfo.logo,
      };
    },
    methods: {
      handleResize() {
        this.windowWidth = window.innerWidth;
      },
    },
    created() {
      window.addEventListener("resize", this.handleResize);
      this.handleResize();
    },
  };
  </script>
  
  <style lang="scss">
  .vx-card {
    background: none !important;
  }
  
  .login-tabs-container {
    .con-tab {
      padding-bottom: 14px;
    }
  
    .con-slot-tabs {
      margin-top: 1rem;
    }
  }
  
  .login-bg {
    height: 85vh;
    width: 100%;
    border-radius: 1rem;
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.4);
    filter: contrast(115%);
  }
  
  .logo {
     margin-top: 3rem;
    width: 15rem;
  }
  </style>
  <style scoped>
  .top-left-button {
    position: absolute;
    top: 10px;
    left: 10px;
  }
  </style>
  